// extracted by mini-css-extract-plugin
module.exports = {"flagHeader":"RegionContainer-module__flagHeader___20p_f","flagTitle":"RegionContainer-module__flagTitle___1Su4T"};